// @ts-nocheck
import classNames from 'classnames';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import styles from './ColumnsHeader.module.scss';
import TableCheckbox from '../TableCheckbox/TableCheckbox';

const SorterIcon = ({ state }) => {
    return (
        <span className={`${styles.sorterIcon} ${styles[state]}`}>
            <CaretUpOutlined className={styles.upArrow} />
            <CaretDownOutlined className={styles.downArrow} />
        </span>
    );
};

const ColumnsHeader = props => {
    const { expandIcon, tableColumns, onSortClick, sortProps, rowSelection, onSelect, isAllSelected } = props;

    const getSorterState = key => (sortProps.key === key ? sortProps.direction : '');

    return (
        <thead>
            <tr>
                {expandIcon ? <th className={'expandIcon'} /> : null}
                {rowSelection ? (
                    <th className={'checkbox'}>
                        <TableCheckbox checked={isAllSelected} onSelect={onSelect} />
                    </th>
                ) : null}
                {tableColumns.map(column => {
                    return (
                        <th
                            key={column.key}
                            className={classNames(styles.columnHeader, column.className, {
                                hasSorter: column.sorter,
                            })}
                            style={{ width: column.width, minWidth: column.width }}
                            onClick={() => column.sorter && onSortClick(column.key, column.sorter)}
                        >
                            <div className={styles.columnTitle}>
                                <span>{column.title}</span>
                                {column.sorter && (
                                    <div className={styles.sortersContainer}>
                                        <SorterIcon state={getSorterState(column.key)} />
                                    </div>
                                )}
                            </div>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

export default ColumnsHeader;
